import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  Typography,
  FormHelperText,
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { Add } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";




const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const LegalAuthorizationForm = ({ onChildData }) => {
  const [legalAuthorization, setLegalAuthorization] = useState({
    eu_work_authorization: '',
    us_work_authorization: '',
    requires_us_visa: '',
    requires_us_sponsorship: '',
    requires_eu_visa: '',
    legally_allowed_to_work_in_eu: '',
    legally_allowed_to_work_in_us: '',
    requires_eu_sponsorship: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLegalAuthorization({ ...legalAuthorization, [name]: value });
    onChildData({legal_authorization:{ ...legalAuthorization, [name]: value}});
    setErrors({ ...errors, [name]: false }); // Clear error when user makes a selection
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    // Check for empty fields
    for (const key in legalAuthorization) {
      if (legalAuthorization[key] === '') {
        newErrors[key] = true; // Set error for empty fields
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Set errors state
      return; // Prevent form submission
    }

  // Format output
  const output = `legal_authorization:\n  eu_work_authorization: "${legalAuthorization.eu_work_authorization}"\n  us_work_authorization: "${legalAuthorization.us_work_authorization}"\n  requires_us_visa: "${legalAuthorization.requires_us_visa}"\n  requires_us_sponsorship: "${legalAuthorization.requires_us_sponsorship}"\n  requires_eu_visa: "${legalAuthorization.requires_eu_visa}"\n  legally_allowed_to_work_in_eu: "${legalAuthorization.legally_allowed_to_work_in_eu}"\n  legally_allowed_to_work_in_us: "${legalAuthorization.legally_allowed_to_work_in_us}"\n  requires_eu_sponsorship: "${legalAuthorization.requires_eu_sponsorship}"`;

  console.log(output);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3,pt:0,pb:2 }}>
      <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h6">Legal Authorization</Typography>
          </AccordionSummary>
          <AccordionDetails>
          <FormControl required error={errors.eu_work_authorization} sx={{ mb: 2,display:'block' }}>
        <Typography variant="body2">EU Work Authorization?</Typography>
        <RadioGroup
          name="eu_work_authorization"
          value={legalAuthorization.eu_work_authorization}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.eu_work_authorization && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.us_work_authorization} sx={{ mb: 2 ,display:'block' }}>
        <Typography variant="body2">US Work Authorization?</Typography>
        <RadioGroup
          name="us_work_authorization"
          value={legalAuthorization.us_work_authorization}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.us_work_authorization && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.requires_us_visa} sx={{ mb: 2,display:'block'  }}>
        <Typography variant="body2">Requires US Visa?</Typography>
        <RadioGroup
          name="requires_us_visa"
          value={legalAuthorization.requires_us_visa}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.requires_us_visa && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.requires_us_sponsorship} sx={{ mb: 2 ,display:'block' }}>
        <Typography variant="body2">Requires US Sponsorship?</Typography>
        <RadioGroup
          name="requires_us_sponsorship"
          value={legalAuthorization.requires_us_sponsorship}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.requires_us_sponsorship && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.requires_eu_visa} sx={{ mb: 2,display:'block'  }}>
        <Typography variant="body2">Requires EU Visa?</Typography>
        <RadioGroup
          name="requires_eu_visa"
          value={legalAuthorization.requires_eu_visa}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.requires_eu_visa && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.legally_allowed_to_work_in_eu} sx={{ mb: 2,display:'block'  }}>
        <Typography variant="body2">Legally Allowed to Work in EU?</Typography>
        <RadioGroup
          name="legally_allowed_to_work_in_eu"
          value={legalAuthorization.legally_allowed_to_work_in_eu}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.legally_allowed_to_work_in_eu && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.legally_allowed_to_work_in_us} sx={{ mb: 2 ,display:'block' }}>
        <Typography variant="body2">Legally Allowed to Work in US?</Typography>
        <RadioGroup
          name="legally_allowed_to_work_in_us"
          value={legalAuthorization.legally_allowed_to_work_in_us}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.legally_allowed_to_work_in_us && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <FormControl required error={errors.requires_eu_sponsorship} sx={{ mb: 2,display:'block'  }}>
        <Typography variant="body2">Requires EU Sponsorship?</Typography>
        <RadioGroup
          name="requires_eu_sponsorship"
          value={legalAuthorization.requires_eu_sponsorship}
          onChange={handleChange}
          row
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
        {errors.requires_eu_sponsorship && <FormHelperText>This field is required.</FormHelperText>}
      </FormControl>

      <Button type="submit" variant="contained" sx={{display:'none'}}>
        Submit
      </Button>
          </AccordionDetails>
        </Accordion>
      
    </Box>
  );
};

export default LegalAuthorizationForm;